import React from "react";
import { useTranslation } from "../../i18n/LanguageContext";

function NoDataMessage() {
   const { t } = useTranslation();
   return (
      <div>
         <span className="d-flex justify-content-center mt-5 no-data-message">
            {t("no-data-available-to-display-text")}
         </span>
      </div>
   );
}

export default NoDataMessage;
